export const BROKERAGE_GROUPS_FUSE_OPTIONS = {
	keys: [
		'name',
		'contactEmail',
		'phoneNumber',
		'claimsEmail',
		'website',
		'fspNumber',
		'address',
		'country',
		'ledger',
		'members.name',
	],
	threshold: 0.2,
};
export const DEFAULT_HIDDEN_BROKERAGE_COLUMNS = [
	'claimsEmail',
	'website',
	'fspNumber',
	'address',
	'country',
	'ledger',
	'lastUpdatedBy',
];
